import React from 'react';
import { DealerConfigResult } from 'pages/Shared/DealerConfigResult';
import DealerLayout from 'components/Layout/Dealer/DealerLayout';

export const DealerConfigResultDealerView: React.FC = () => {
  return (
    <DealerLayout>
      <DealerConfigResult />
    </DealerLayout>
  );
};
